/**
 * Auth-related domain constants.
 */

/**
 * How old the current Firebase session's last sign-in may be before the
 * Delete Account page forces a fresh (re-)authentication: 30 days, in ms.
 *
 * WEB-ONLY threshold — there is NO Flutter source for this figure. Flutter's
 * delete flow does not re-authenticate at all (its `user.delete()` is commented
 * out, `lib/services/app_authentication_service.dart:407-419`). The 30-day
 * staleness rule is added by the web task prompt only
 * (`workflow/task_prompts/feat_delete_account_page_task_prompt.md` lines 51-53:
 * "Signed in, last sign-in older than 30 days → show login" to force a fresh
 * sign-in). Do not treat this as a ported Flutter constant.
 */
export const SESSION_STALE_THRESHOLD_MS = 30 * 24 * 60 * 60 * 1000;
